import { Injectable } from '@angular/core';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material';
import { ModalComponent } from '../modal/modal.component';
import { CreateContractComponent } from '../create-contract/create-contract.component';
import { CreateContractLayerComponent } from '../create-contract-layer/create-contract-layer.component';
import { ContractPresentToMarketComponent } from '../contract-present-to-market/contract-present-to-market.component';
import { ContractQuoteStructureAddComponent } from '../contract-quote-structure-add/contract-quote-structure-add.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog) { }

  open(p: {title?: string} = {}): MatDialogRef<ModalComponent> {
    const config     = new MatDialogConfig();
    config.data      = { title: p.title };
    config.minHeight = '400px';
    config.width     = '640px';
    return this.dialog.open(ModalComponent, config);
  }

  openCreateContractLayers(data: any): MatDialogRef<CreateContractLayerComponent> {
    const config     = new MatDialogConfig();
    config.data      = { data };
    config.minHeight = '400px';
    config.width     = '640px';

    return this.dialog.open(CreateContractLayerComponent, config);
  }

  openPresentToMarket() {
    const config     = new MatDialogConfig();
    config.data      = { title: 'Present to Market - Quote' };
    config.minHeight = '400px';
    config.width     = '800px';

    return this.dialog.open(ContractPresentToMarketComponent, config);
  }

  openCreateContract() {
    const config      = new MatDialogConfig();
    config.data       = { title: 'Create Contract' };
    config.minHeight  = '400px';
    config.width      = '800px';
    config.panelClass = 'create-contract';

    return this.dialog.open(CreateContractComponent, config);
  }

  openAddQuoteStructure() {
    const config     = new MatDialogConfig();
    config.data      = { title: 'Add Quote Structure' };
    config.minHeight = '400px';
    config.width     = '800px';

    return this.dialog.open(ContractQuoteStructureAddComponent, config);
  }
}
